import React, { useEffect, useState } from 'react'
import IconButton from '@mui/material/IconButton'
import { StarIcon } from 'lucide-react'
import { useTheme } from '@mui/material/styles'
import { useRevalidator } from 'react-router'
import Tooltip from '@mui/material/Tooltip'
import { WatchListsApi } from '../../api/WatchListApi'
import { WatchListItemType } from '@finance-lab/utils/types'

const watchListApi = new WatchListsApi()

export const WatchListButton = ({
    disabled,
    entityId,
    isInWatchList,
    type,
}:
    | {
          disabled?: undefined
          entityId: string
          isInWatchList: boolean
          type: WatchListItemType
      }
    | { disabled: true; entityId?: string; isInWatchList: boolean; type?: WatchListItemType }) => {
    const [isLoading, setIsLoading] = useState(false)
    const [isOptimisticInWatchList, setIsOptimisticInWatchList] = useState(isInWatchList)
    const revalidator = useRevalidator()
    const theme = useTheme()

    useEffect(() => {
        setIsOptimisticInWatchList(isInWatchList)
    }, [isInWatchList])

    const handleClick = () => {
        if (disabled) return

        void (async () => {
            try {
                setIsLoading(true)
                if (isOptimisticInWatchList) {
                    await watchListApi.deleteItem(type, entityId)
                } else {
                    await watchListApi.createItem(type, entityId)
                }
                setIsOptimisticInWatchList(!isOptimisticInWatchList)
            } catch (err) {
                console.error(err)
            } finally {
                setIsLoading(false)
                revalidator.revalidate()
            }
        })()
    }

    const title = isOptimisticInWatchList ? 'Avsluta bevakning' : 'Bevaka'

    const button = (
        <IconButton
            aria-label={title}
            disabled={disabled}
            loading={isLoading}
            onClick={handleClick}
            sx={{ marginLeft: 4 }}
        >
            <StarIcon
                color={theme.palette.primary.main}
                fill={theme.palette.primary.main}
                fillOpacity={isOptimisticInWatchList ? 1 : 0}
                opacity={isLoading ? 0 : 1}
                style={{
                    transition: 'opacity 0.3s',
                }}
            />
        </IconButton>
    )

    if (disabled) return button

    return <Tooltip title={title}>{button}</Tooltip>
}
